export default __webpack_public_path__ + "static/media/gen_3880.cd4aa527.png";